import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import {CardHeader, Typography, Box} from "@mui/material";
import {Helmet} from "react-helmet";
import React from "react";
import {Crumbs} from "../Crumbs.jsx";

const desc = "How your information is used and stored by Austin 2 Step"

const title = "Privacy Policy"

export const PrivacyPage = () => <div>
    <Crumbs crumbs={
        [
            {title: "This Site"},
            {title: "Privacy"}
        ]} />
     <Helmet>
        <meta charSet="utf-8"/>
        <meta property="og:description" content={desc}/>
        <meta property="twitter:title" content={title}/>
        <meta property="twitter:description" content={desc}/>
        <title>{title}</title>
        <meta property="description" content={desc} />
        <link rel="canonical" href="https://austin2step.com/privacy"/>
    </Helmet>
    <Card>
        <CardHeader title={"Privacy Policy"} subheader={"For Humans"}/>
        <CardContent>
            <Box pb={3}>
                <Typography variant={"subtitle2"} gutterBottom><i>Updated on August 18, 2025</i></Typography>
            </Box>
            <Typography variant={"h5"} gutterBottom>Cookies</Typography>
            <Typography variant={"body2"} gutterBottom>Cookies are used for site analytics.</Typography>
            <Typography variant={"body2"}>3rd party cookies from Google Analytics are used to track site usage patterns. This industry standard tool allows the site to see which pages are being accessed and what kind of devices are being used. There is no personally identifiable information collected by this tool such as your name or email address.</Typography>
            <br />

            <Typography variant={"h5"}>Personal Information</Typography>
            <Typography variant={"overline"} gutterBottom>Email Address</Typography>
            <Typography variant={"body2"} gutterBottom>A valid email address is required to open an account. This account allows features to be used that need to be tied to a user, like RSVPing to events or adding events to the calendar.</Typography>
            <Typography variant={"body2"} gutterBottom>Your email address is used for site functionality only, and IS NOT used for any of the following:</Typography>
            <Typography variant={"body2"}><ul>
                <li>Marketing / Spam</li>
                <li>Sold / Disclosed to 3rd parties</li>
                <li>Publicly displayed on the website</li>
            </ul></Typography>

            <Typography variant={"overline"} gutterBottom>Public Profile</Typography>
            <Typography variant={"body2"} gutterBottom>A public profile is <i>optional</i> when you sign up for an account. This profile is visible to other users and may include your name, profile picture, and will be attached to any content you create.</Typography>
            <Typography variant={"body2"} gutterBottom>You may delete your public profile at any time through your account settings page.</Typography>
            <Typography variant={"body2"} gutterBottom>Public Profiles have the option to add:</Typography>
            <Typography variant={"body2"}><ul>
                <li>Profile Pic</li>
                <li>Public Name</li>
                <li>Social Links</li>
            </ul></Typography>
            <Typography variant={"body2"} gutterBottom>Adding a public profile will NOT make your email address public in any way.</Typography>

        </CardContent>
    </Card>
</div>